
define('text!libs/strand/src/strand-sync/example.html',[],function () { return ' <template is="dom-bind">\n\t<strand-sync id="search" endpoint="https://api.github.com/search/code?q=polymer+in:file+language:js+repo:polymer/polymer" data="{{data}}" auto>\n\t</strand-sync>\n\t<template is="dom-repeat" items="{{data.items}}">\n\t\t<span>{{item.name}}</span>\n\t</template>\n</template>';});

